import React from 'react';
import { Form } from 'react-bootstrap';

import {
  CreateUpdateApplicationDto,
  CreateUpdateClientDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';

import { EveryClientFormFields } from './EveryClientFormFields';

interface EveryClientProps {
  client: CreateUpdateClientDto | CreateUpdateApplicationDto;
  propertyChange?: (obj: Partial<CreateUpdateClientDto>) => void;
  findByNip?: (text: string) => void;
  readonly?: boolean;
}

export const EveryClient: React.FC<EveryClientProps> = props => {
  return (
    <Form className="d-grid gap-4">
      <EveryClientFormFields
        client={props.client}
        propertyChange={props.propertyChange}
        findByNip={props.findByNip}
        readonly={props.readonly}
      />
    </Form>
  );
};
